export default {
  sans: ['sans-serif'],
  heading: ['serif'],
  nav: ['serif'],
  serif: ['serif'],
  mono: ['monospace']
} 